import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Router } from 'react-router-dom';
import '@fontsource/montserrat';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <body
        style={{
            width: '100%',
            minHeight: '100vh',
            backgroundColor: '#000000',
        }}
    >
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </body>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
